module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - malsae1.299a98ed.pdf";